import {Component, inject, OnInit} from '@angular/core';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {BalaoSugestaoComponent} from './balao-sugestao/balao-sugestao.component';
import {InfoUsuarioComponent} from './info-usuario/info-usuario.component';
import {ImagensUsuarioPerfilModel} from '../shared/model/usuario/imagens-usuario-perfil.model';
import {Usuario} from '../shared/model/usuario/usuario.model';
import {AuthService} from '../shared/service/auth.service';
import {UsuarioService} from '../shared/service/usuario.service';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {CanaisUsuariosComponent} from './canais-usuarios/canais-usuarios.component';
import {MsgService} from '../shared/service/msg.service';
import {BalaoUsuarioAdComponent} from './balao-usuario-ad/balao-usuario-ad.component';

@Component({
  selector: 'app-usuario-perfil',
  standalone: true,
  imports: [
    FormFieldComponent,
    TituloRotinaComponent,
    BalaoSugestaoComponent,
    InfoUsuarioComponent,
    ButtonPadraoComponent,
    CanaisUsuariosComponent,
    BalaoUsuarioAdComponent
  ],
  templateUrl: './usuario-perfil.component.html',
  styleUrl: './usuario-perfil.component.css'
})
export class UsuarioPerfilComponent implements OnInit {

  usuarioLogado: Usuario = new Usuario();

  senhasObj = {
    senhaAtual: '',
    novaSenha: '',
    confirmacaoNovaSenha: ''
  }

  imgUsuario: ImagensUsuarioPerfilModel = new ImagensUsuarioPerfilModel();
  senhasEquivalentes = false;

  private readonly usuarioService = inject(UsuarioService);
  private readonly msgService = inject(MsgService);
  private readonly authService = inject(AuthService);

  ngOnInit() {
    this.usuarioService.buscarUsuarioLogado().subscribe({
      next: res => {
        this.usuarioLogado = res;
      }
    });
  }

  receberImgUsuario(event: ImagensUsuarioPerfilModel){
    this.imgUsuario = event;
    this.usuarioLogado.extensaoImg = event.extensaoImg;
    this.usuarioLogado.imgBase64 = event.imgBase64;
    this.fazerUploadImagemUsuario();
  }

  fazerUploadImagemUsuario(){
    this.usuarioService.uploadImgUsuario(this.usuarioLogado).subscribe({
      next: () => {
        this.msgService.msgSucesso('Imagem adicionada com sucesso.');
      }
    });
  }

  verificarConfirmacaoSenha(event: any){
    if(this.senhasObj.novaSenha === event)
      this.senhasEquivalentes = true;
    else
      this.senhasEquivalentes = false;

    this.senhasObj.confirmacaoNovaSenha = event;
  }

  trocarSenhaUsuario(){
    if(this.validarSenha()){
      if(this.senhasEquivalentes){
        this.usuarioService.trocarSenhaUsuario({ idUsuario: this.usuarioLogado.id, senhaAtual: this.senhasObj.senhaAtual, novaSenha: this.senhasObj.novaSenha, confirmacaoNovaSenha: this.senhasObj.confirmacaoNovaSenha }).subscribe({
          next: () => {
            this.msgService.msgSucesso('Senha alterada com sucesso.');
          }
        });
      }
      else{
        this.msgService.msgAdvertencia('As senhas precisam ser identicas.');
      }
    }
  }

  validarSenha(): boolean{
    if(!this.senhasObj.senhaAtual){
      this.msgService.msgAdvertencia('Informe a senha atual');
      return false;
    }
    if(!this.senhasObj.novaSenha){
      this.msgService.msgAdvertencia('Informe a nova senha');
      return false;
    }
    if(!this.senhasObj.confirmacaoNovaSenha){
      this.msgService.msgAdvertencia('Informe a confirmação da nova senha');
      return false;
    }
    return true;
  }

  logout() {
    this.authService.logout();
  }

}
